import { useEffect, useState } from 'react'

/* 
Takes initial state and delay in miliseconds as arguments.
Regular state is updated immediately, which can be a problem when you want to use it for filtering or searching.
Provides a debounced version of the state, which is updated after a delay - to not send API requests on every key press.
Regilar setState is also provided, to be used for immediate updates.
*/

export const useDebouncedState = <T,>(initialState: T, delay: number) => {
  const [state, setState] = useState<T>(initialState)
  const [debouncedState, setDebouncedState] = useState<T>(initialState)

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedState(state), delay)
    return () => clearTimeout(handler)
  }, [state, delay])

  return [state, debouncedState, setState] as const
}
